import useLanguage from '@op/hooks/useLanguage';
import { useCallback } from 'react';
const needTranslate = [
  'All',
  'Global',
  'Global except China mainland',
  'Account',
  'Keyword',
  'External Sources',
];

export default function useTranslate() {
  const { formatMessage } = useLanguage();

  const needTranslateElement = useCallback(
    (value: string) => {
      return needTranslate.includes(value)
        ? formatMessage({ id: value })
        : value;
    },
    [formatMessage],
  );

  const translateInfo = useCallback(
    (value: any) => {
      if (Array.isArray(value) && typeof value[0] === 'string') {
        return value.map(item => needTranslateElement(item)).join(' ');
      }
      return needTranslateElement(value);
    },
    [formatMessage],
  );

  return {
    formatMessage,
    translateInfo,
    needTranslateElement,
  };
}
